module.exports = __webpack_public_path__ + "static/img/2.cfe0b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/third/2.png
// module id = jnWP
// module chunks = 6